<template>
    <div class="detail">
      <div class="head">
        <div class="left">
        {{ getTitle() }}详情
        </div>
        <div class='close' @click='close'>
          <img src='@/assets/images/home/back.png'/>
      返回
        </div>
      </div>
       <components :is="activeName" :ref="activeName+'Ref'" :row="row" :appStatusObj="appStatusObj" :appTypeObj="appTypeObj" :orderTypeObj="orderTypeObj"></components>
    </div>
</template>
<script >
import Order from './components/Order.vue'
import Receipt from './components/Receipt.vue'
import Waybill from './components/Waybill.vue'
import Manifest from './components/Manifest.vue'
import ListTotal from './components/ListTotal.vue'
import DeclarationDeparture from './components/DeclarationDeparture.vue'
import summarySheet from './components/summarySheet.vue'
import DeclarationNote from './components/DeclarationNote.vue'
const {mapState} = require('vuex')
export default {
  components: {Order, Receipt, Waybill, Manifest, ListTotal, DeclarationDeparture, summarySheet, DeclarationNote},
  data () {
    return {
      activeName: '',
      row: {},
      appStatusObj: {
        '1': '暂存',
        '2': '申报'
      },
      appTypeObj: {
        '1': '新增',
        '2': '变更',
        '3': '删除'
      },
      orderTypeObj: {
        'E': 'B2C出口订单',
        'B': 'B2C出口订单',
        'W': '海外仓订仓单'
      }
    }
  },
  computed: {
    ...mapState({
      showDetail: (state) => {
        return state.home.showDetail
      }
    })
  },
  created () {
    this.row = this.showDetail
    this.activeName = this.showDetail.activeName
  },
  methods: {
    getTitle () {
      let activeName = this.activeName
      switch (activeName) {
        case 'Order':
          return '订单申报'
        case 'Receipt':
          return '收款单申报'
        case 'Waybill':
          return '运单申报'
        case 'Manifest':
          return '清单申报'
        case 'ListTotal':
          return '清单总分单申报'
        case 'DeclarationNote':
          return '运抵单申报'
        case 'DeclarationDeparture':
          return '离境单申报'
        case 'summarySheet':
          return '汇总单申报'
      }
    },
    // 关闭弹框
    close () {
      this.$store.dispatch('getisShowDetail', 1)
      this.$store.dispatch('getShowDetail', {})
    }
  }
}
</script>
<style lang="scss" scoped>
.detail{
  padding: 40px;
  .head{
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.close{
        display: flex;
        box-sizing: content-box;
        padding: 5px;
        height: 24px;
        cursor: pointer;
        width: 87px;
    height: 30px;
    font-size: 20px;
    cursor: pointer;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/detail.vue